import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class DocumentOrigin extends Enum {
  key!: string;
  value!: string;
  static PLANNING_LAST_WILL_TESTAMENT: DocumentOrigin = {
    key: 'planning_last_will_testament',
    get value() {
      return Lang.t('document.origin-will');
    }
  };

  static GUIDANCE: DocumentOrigin = {
    key: 'guidance',
    get value() {
      return Lang.t('document.origin-guidance');
    }
  };

  static MANUAL: DocumentOrigin = {
    key: 'manual',
    get value() {
      return Lang.t('document.origin-manual');
    }
  };
}
